'use client';
import React, { useState, useEffect, useRef } from 'react';
import { AxiosInstance } from '../utils';
import { ScheduleTab } from './scheduletab';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Switch from "react-switch";
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import validator from 'validator';
import { BookingType, InputComponent, QuantityComponent, PayType, DropDownComponent } from '../custcomponents';

import { ToastContainer, toast } from 'react-toastify';


function onIncrementTicket(ticketType: any, ticketCount: any, setTicketCount: any) {
    let newcount = (ticketCount[ticketType] || 0) + 1;
    setTicketCount({
        ...ticketCount,
        [ticketType]: newcount
    });
}
function onDecrementTicket(ticketType: any, ticketCount: any, setTicketCount: any) {
    let newcount = (ticketCount[ticketType] || 0) - 1;
    if (newcount < 0) {
        return;
    }
    setTicketCount({
        ...ticketCount,
        [ticketType]: newcount
    });
}

function getGroupTicketTypes(eventInfo: any, ticketCount: any, setTicketCount: any) {


    let ticketTypeshtml: any = [];
    if (eventInfo.tickettypes != null) {
        Object.keys(eventInfo.tickettypes).forEach(key => {
            if (!eventInfo.tickettypes[key]?.allowbulkbooking || eventInfo.tickettypes[key]?.allowbulkbooking == "YES")
            {
                ticketTypeshtml.push(
                    <QuantityComponent custname={key} price={eventInfo.tickettypes[key].price} custid="txtgrpCompany" custplaceholder={key} currentValue={ticketCount?.[key]} onIncrement={onIncrementTicket} onDecrement={onDecrementTicket} ticketCount={ticketCount} setTicketCount={setTicketCount} />
                );
            }
           
        });
    }

    return (
        <>
            {ticketTypeshtml}
        </>
    );
}
function getIndividualTotalPriceTax(eventInfo: any, ticketTypeSelected: any, discountObj: any, couponCode: any) {

    let ticketCount = 1;
    let ticketTypeshtml: any = [];
    let overallTotal = 0;
    let calculatedDiscount = 0;
    if (eventInfo.tickettypes != null) {
        Object.keys(eventInfo.tickettypes).forEach(key => {

            if (key == ticketTypeSelected) {
                overallTotal += eventInfo.tickettypes[key].price * (ticketCount);
                if (discountObj) {
                    if (discountObj.discounttype == "percentage") {
                        calculatedDiscount = overallTotal * (discountObj.discount / 100)
                        overallTotal -= calculatedDiscount;
                    }
                }
                ticketTypeshtml.push(<div className="ticketsummary-item" >
                    <div className="ticketsummary-left">{key} {eventInfo.tickettypes[key].price} x {ticketCount}</div>
                    <div className="ticketsummary-right">:  &#8377; {(eventInfo.tickettypes[key].price * ticketCount)}</div>
                </div>);
                if (calculatedDiscount > 0) {
                    ticketTypeshtml.push(<div className="ticketsummary-item" >
                        <div className="ticketsummary-left">Coupon Code {couponCode} </div>
                        <div className="ticketsummary-right">:  &#8377; -{calculatedDiscount.toFixed(2)}</div>
                    </div>);
                }
            }
        });
    }

    ticketTypeshtml.push(
        <hr className="dotted"></hr>
    );
    ticketTypeshtml.push(
        <div className="ticketsummary-total" >
            <div className="ticketsummary-left">GST 18% </div>
            <div className="ticketsummary-right">:  &#8377; {((overallTotal || 0) * 0.18).toFixed(2)}</div>
        </div>
    );
    ticketTypeshtml.push(
        <div className="ticketsummary-total" >
            <div className="ticketsummary-left">Total</div>
            <div className="ticketsummary-right">:  &#8377; {((overallTotal || 0) * 1.18).toFixed(2)}</div>
        </div>
    );
    return (
        <>
            {ticketTypeshtml}
        </>
    );
}

function getGrpDiscount(ticketTypeObj: any, key:any,ticketCount: any)
{
    console.log(ticketTypeObj);
    if (ticketTypeObj.discountData)
    {
        let i:any=0;
       for(  i=0;i<ticketTypeObj.discountData.length;i++)
       {
           console.log(ticketCount);
        if (ticketCount >= ticketTypeObj.discountData[i].from && ticketCount <= ticketTypeObj.discountData[i].to)
        {
            console.log('apply discount');
            return (ticketTypeObj.discountData[i].discountpercentage/100);
        }
       }
    }
    return 0;
}

function getDiscountTable(eventInfo: any, ticketCount: any, setTicketCount: any) {
    let discounthtml: any = [];
    let discountrows: any = [];
  
    if (eventInfo.tickettypes != null) {
        Object.keys(eventInfo.tickettypes).forEach(key => {
           let ticketTypeObj:any =  eventInfo.tickettypes[key];
            if (ticketTypeObj.discountData)
            {
                discountrows.push(<tr><th>Pass Type</th> <th>Ticket From</th> <th>Ticket To</th> <th>Discount %</th></tr>)
               
                let i:any=0;
               for(  i=0;i<  ticketTypeObj.discountData.length; i++)
               {
                discountrows.push(<tr><td>{key}</td> <td>{ticketTypeObj.discountData[i].from}</td> <td>{ticketTypeObj.discountData[i].to}</td> <td>{ticketTypeObj.discountData[i].discountpercentage}</td></tr>)
                  
               }
            }
        });

        if(discountrows.length>0)
        {
            discounthtml.push(<table className="discounttable">{discountrows}</table>)
        }
        else{
            discounthtml.push(<h2 className="blacktext">Watch out for great group discounts after Early Bird offer! Do not miss the Early Bird offer which is the best discount by far!</h2>)  
        }

    }
        return (
            <>
            {discounthtml}
            </>
        )
}
function getTotalPriceTax(eventInfo: any, ticketCount: any, setTicketCount: any) {


    let ticketTypeshtml: any = [];
    let overallTotal = 0;
    let discountTotal = 0;
    if (eventInfo.tickettypes != null) {
        Object.keys(eventInfo.tickettypes).forEach(key => {
            if (!eventInfo.tickettypes[key]?.allowbulkbooking || eventInfo.tickettypes[key]?.allowbulkbooking == "YES")
            {
            overallTotal += eventInfo.tickettypes[key].price * (ticketCount?.[key] || 0);
            discountTotal += (eventInfo.tickettypes[key].price * (ticketCount?.[key] || 0) ) * getGrpDiscount(eventInfo.tickettypes[key], key, (ticketCount?.[key] || 0));
            ticketTypeshtml.push(<div className="ticketsummary-item" >
                <div className="ticketsummary-left">{key} {eventInfo.tickettypes[key].price} x {ticketCount?.[key] || 0}</div>
                <div className="ticketsummary-right">:  &#8377; {(eventInfo.tickettypes[key].price * ticketCount?.[key]) || 0}</div>
            </div>);
            }
        });
    }
    ticketTypeshtml.push(
        <hr className="dotted"></hr>
    );
    ticketTypeshtml.push(
        <div className="ticketsummary-total" >
            <div className="ticketsummary-left">Discount</div>
            <div className="ticketsummary-right">:  &#8377; {discountTotal || 0}</div>
        </div>
    );
    ticketTypeshtml.push(
        <div className="ticketsummary-total" >
            <div className="ticketsummary-left">GST 18%</div>
            <div className="ticketsummary-right">:  &#8377; {(((overallTotal || 0)- (discountTotal || 0))*0.18).toFixed(2)}</div>
        </div>
    );
    ticketTypeshtml.push(
        <div className="ticketsummary-total" >
            <div className="ticketsummary-left">Total</div>
            <div className="ticketsummary-right">:  &#8377; {(((overallTotal || 0)- (discountTotal || 0)) * 1.18).toFixed(2)}</div>
        </div>
    );
    return (
        <>
            {ticketTypeshtml}
        </>
    );
}
function validate(fieldName, fieldValue, validatType, canNull) {
    let isvalid = true;
    if (!canNull) {
        if (fieldValue == null || fieldValue == '') {
            toast.error(`${fieldName} cannot be Blank.`);
            return false;
        }
    }
    switch (validatType) {
        case 'email':
            if (!validator.isLength(fieldValue, { min: 0, max: 70 })) {
                toast.error(`Invalid Email. Field: ${fieldName}.`);
                isvalid = false;
            }
            break;
        case 'name':
            if (!validator.isLength(fieldValue, { min: 0, max: 60 })) {
                toast.error(`Invalid Data. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'phonenumber':
            if (fieldValue != null && !validator.isLength(fieldValue, { min: 0, max: 15 })) {
                toast.error(`Invalid mobile number. Field: ${fieldName}`)
                isvalid = false;
            }
            break;
        case 'url':
            if (!validator.isLength(fieldValue, { min: 0, max: 100 })) {
                toast.error(`Invalid url. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'linkedinurl':
            if (fieldValue != null && !validator.isLength(fieldValue, { min: 0, max: 256 })) {
                toast.error(`Invalid linkedin Url. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'tshirtsize':
            if (!validator.isLength(fieldValue, { min: 0, max: 6 })) {
                toast.error(`Invalid T-Shirt Size. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'gender':
            if (!validator.isLength(fieldValue, { min: 0, max: 6 })) {
                toast.error(`Invalid Gender. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'ticketType':
            if (!validator.isLength(fieldValue, { min: 0, max: 200 })) {
                toast.error(`Invalid Pass Type. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'title':
            if (!validator.isLength(fieldValue, { min: 0, max: 60 })) {
                toast.error(`Invalid Data. Field: ${fieldName}, field value ${fieldValue}`);
                isvalid = false;
            }
            break;
        case 'groupType':
            if (!validator.isLength(fieldValue, { min: 0, max: 60 })) {
                toast.error(`Invalid Data. Field: ${fieldName}, field value ${fieldValue}`);
                isvalid = false;
            }
            break;

    }

    switch (validatType) {
        case 'email':
            if (!validator.matches(fieldValue, /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                toast.error(`Invalid Email. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'officeemail':
            if (fieldValue != null && !validator.isEmpty(fieldValue) && !validator.matches(fieldValue, /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                toast.error(`Invalid Email. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'name':
            if (!validator.isAlphanumeric(fieldValue, 'en-US', { ignore: ' .-\'' })) {
                toast.error(`Invalid Data. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'phonenumber':
            if (!validator.matches(fieldValue, /^[0-9]{10}$/)) {
                toast.error(`Invalid mobile number. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'trainingid':
            if (!validator.matches(fieldValue, /^[0-9]{1,3}$/)) {
                toast.error(`Invalid mobile number. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'url':
            if (!validator.isURL(fieldValue)) {
                toast.error(`Invalid mobile number. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'linkedinurl':
            if (fieldValue != null && !validator.isEmpty(fieldValue) && (!validator.isURL(fieldValue) || !validator.contains(fieldValue, 'linkedin.com', { ignoreCase: true }))) {
                toast.error(`Invalid linkedin Url. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'tshirtsize':
            if (!validator.matches(fieldValue, 'S|M|L|XL|XXL|XXXL')) {
                toast.error(`Invalid T-Shirt Size. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'gender':
            if (!validator.matches(fieldValue, 'Male|Female|Other')) {
                toast.error(`Invalid Gender. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'ticketType':
            //if(!validator.matches(fieldValue, 'Student Pass|Member Pass|Individual Pass|Corporate Pass'))
            if (validator.matches(fieldValue, 'Pass Type')) {
                toast.error(`Invalid Pass Type. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'trainingplan':
            if (!validator.matches(fieldValue, 'NonMember|Member')) {
                toast.error(`Invalid Plan. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'groupType':
            if (!validator.matches(fieldValue, 'BSides Bangalore|W3-CS')) {
                toast.error(`Invalid Group. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'parking':
            if (!validator.matches(fieldValue, 'No|2 Wheeler|4 Wheeler')) {
                toast.error(`Invalid Parking . Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'eventcode':
            if (!validator.matches(fieldValue, /^[a-zA-Z0-9]{4,10}$/)) {
                toast.error(`Invalid Training interest. Field: ${fieldName}`);
                isvalid = false;
            }
            break;

    }

    return isvalid;
}
export const GroupRegistration = ({ eventInfo }: any) => {

    const [ticketCount, setTicketCount] = useState({});
    const [payType, setPayType] = useState('PayNow');
    const formGrpRef = useRef(null as any);
    const idvPayGrpForm = useRef(null as any);
    const [grpPayGrpString, setGrpPayGrpString] = useState('');

    const resetForm = (event) => {

        if (formGrpRef && formGrpRef.current) {
            formGrpRef.current.reset();
        }
        setTicketCount({});
    };
    const updateStr = async (value) => {
        setGrpPayGrpString(value);
    }
    const onformGroupSubmit = async (event: any) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const grpName = formData.get("GroupName");
        const grpmobile = formData.get("GroupMobileNo");
        const grpcompany = formData.get("GroupCompany");
        const grpemail = formData.get("GroupEmail");


        if (!validate('Name', grpName, 'name', false) || !validate('Mobile No', grpmobile, 'phonenumber', false) || !validate('Company', grpcompany, 'name', false) || !validate('E-Mail', grpemail, 'email', false)) {
            return;
        }

        if (ticketCount == null || Object.keys(ticketCount).length == 0) {
            toast.error("Select The tickets.");
            return;
        }

        let ticketsSelected = false;
        Object.keys(ticketCount).forEach((key) => {
            if (ticketCount[key] > 0) {
                ticketsSelected = true;
            }
        })
        if (!ticketsSelected) {
            toast.error("Select The tickets.");
            return;
        }

        if (payType == 'GenerateInvoice') {
            let requestReq = {
                'name': grpName,
                'mobile': grpmobile,
                'company': grpcompany,
                'email': grpemail,
                'ticketdetails': ticketCount,
                'eventcode': eventInfo.eventcode
            };
            const { data: response } = await AxiosInstance.post('/api/createPaylink', requestReq, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.result == "Success") {
                toast(`Paylink has been sent to mobile: ${grpmobile} and email ${grpemail}. Please pay for further instructions. `);
                resetForm(event);
            }
        }
        else if (payType == 'PayNow') {
            let requestReq = {
                'name': grpName,
                'mobile': grpmobile,
                'company': grpcompany,
                'email': grpemail,
                'ticketdetails': ticketCount,
                'eventcode': eventInfo.eventcode
            };
            const { data: response } = await AxiosInstance.post('/api/grpPaynow', requestReq, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.result == "Success") {
                toast(`Payment in progress, mobile: ${grpmobile} and email ${grpemail}. `);
                await updateStr(response.paystring);

                idvPayGrpForm.current.submit();
                resetForm(event);
            }
        }
    }


    const handleRadioChange = (e: any) => {
        setPayType(e.target.value);

    };

    return (
        <>
            <form ref={formGrpRef} onSubmit={onformGroupSubmit}>
                <div className="row">

                    <div className="col-lg-5 col-md-6 col-sm-6">

                        <InputComponent custname="GroupName" custid="txtgrpname" custplaceholder="Name" />
                        <InputComponent custname="GroupMobileNo" custid="txgrptmobile" custplaceholder="Mobile No" />

                        <InputComponent custname="GroupCompany" custid="txtgrpCompany" custplaceholder="Company" />
                        <InputComponent custname="GroupEmail" custid="txtgrpemail" custplaceholder="E-Mail" />
                        <div className="form-field form-label-group-cust ">
                            <span className="heading-header">Select Tickets</span>
                        </div>
                        {getGroupTicketTypes(eventInfo, ticketCount, setTicketCount)}
                    </div>

                    <div className="col-lg-5 col-md-6 col-sm-6">
                        <div className="ticketsummary">
                            <span className="ticketsummary-header">Booking Summary</span>
                            {getTotalPriceTax(eventInfo, ticketCount, setTicketCount)}
                        </div>
                        <div className="pt-5">
                        {getDiscountTable(eventInfo, ticketCount, setTicketCount)}
                        </div>
                    </div>
                </div>
                <div className="row">

                    <div className="col-lg-12">
                        <span style={{ "color": "black" }}>Note:</span>
                    </div>

                </div>
                <PayType handleOnChange={handleRadioChange} currentRadioValue={payType} />
                <div className="row">
                    <div className="col-lg-6">
                        <div className="form-field text-center mgt-40 wow fadeInUp" data-wow-duration="300ms">
                            <button type="submit" className="btn-default">SUBMIT <i className="fa fa-arrow-circle-right"></i></button>
                        </div>
                    </div>
                </div>
            </form>
            <form ref={idvPayGrpForm} action={process.env.NODE_ENV == "development" ? 'http://localhost:5001/bsidesbangalorev2/us-central1/payments-grpPaynowInitiatePayment' : '/api/grpPaynowInitiatePayment'} >
                <input type="hidden" name="idvpaystring" value={grpPayGrpString} />
            </form>
        </>);
}

export const IndividualRegistration = ({ eventInfo }: any) => {

    const [individualTicketSelected, setIndividualTicketSelected] = useState('');
    const [parking, setParking] = useState('Parking');
    const [tshirtsize, setTshirtsize] = useState('T-Shirt Size');
    const [gender, setGender] = useState('Gender');
    const [idvPayString, setIdvPayString] = useState('');
    const [autoMembership, setAutoMembership] = useState(false);
    const [showMembershipModal, setShowMembershipModal] = useState(false);
    const formRef = useRef(null as any);
    const idvPayForm = useRef(null as any);
    const [submitLoading, setSubmitLoading] = useState(false);

    const updateStr = async (value) => {
        setIdvPayString(value);
    }
    const onformIndividualSubmit = async (event: any) => {

        event.preventDefault();
        setSubmitLoading(true);
        const formData = new FormData(event.currentTarget);
        const idvName = formData.get("IdvName");
        const IdvDesignation = formData.get("IdvDesignation");
        const IdvCompany = formData.get("IdvCompany");
        const IdvMobileNo = formData.get("IdvMobileNo");
        const Idvemail = formData.get("Idvemail");
        const Idvlinkedinurl = formData.get("Idvlinkedinurl");
        const IdvGender = formData.get("IdvGender");
        const IdvParking = formData.get("IdvParking");
        const IdvTShirtSize = formData.get("IdvTShirtSize");
        const IdvTicketType = formData.get("IdvTicketType");
        const IdvCouponcode = formData.get("IdvCouponcode");

        if (!validate('Name', idvName, 'name', false) || !validate('Designation', IdvDesignation, 'name', false) || !validate('Company', IdvCompany, 'name', false) ||
            !validate('Mobile No', IdvMobileNo, 'phonenumber', false) || !validate('Linked-in Url', Idvlinkedinurl, 'linkedinurl', false) ||
            !validate('Gender', IdvGender, 'gender', false) ||
            (eventInfo.additionalFields?.parking.enabled && !validate('Parking', IdvParking, 'parking', false)) ||
            (eventInfo.additionalFields?.tshirt.enabled && !validate('T-Shirt Size', IdvTShirtSize, 'tshirtsize', false)) ||
            !validate('E-Mail', Idvemail, 'email', false) || !validate('Pass Type', IdvTicketType, 'ticketType', false)) {
            setSubmitLoading(false);
            return;
        }

        let requestReq = {
            'name': idvName,
            'phonenumber': IdvMobileNo,
            'company': IdvCompany,
            'personalmailid': Idvemail,
            'linkedinurl': Idvlinkedinurl,
            'title': IdvDesignation,
            'gender': IdvGender,
            'tshirtsize': IdvTShirtSize,
            'parking': IdvParking,
            'tickettype': IdvTicketType,
            'couponcode': couponApplied ? IdvCouponcode : null,
            'eventcode': eventInfo.eventcode,
            'automembership': autoMembership
        };
        const { data: response } = await AxiosInstance.post('/api/eventregistration', requestReq, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.result == "Success") {
            toast(`Proceed with Payment. Payment code: ${response.paystring}. `, { autoClose: 100 });
            await updateStr(response.paystring);
            idvPayForm.current.submit();
            // resetForm(event);
            //if (formRef && formRef.current) {
            //     formRef.current.reset();
            //     setIndividualTicketSelected('');
            //     setParking('Parking');
            //      setTshirtsize('T-Shirt Size');
            //      setGender('Gender');
            //  }
        }
        else {
            const errorMsg = response.msg ? response.msg : "Failed to Register";
            if (errorMsg === "Not a Member.") {
                setShowMembershipModal(true);
                setSubmitLoading(false);
            } else {
                toast.error(errorMsg);
                setSubmitLoading(false);
            }
        }

    }

    const handleMembershipYes = () => {
        setShowMembershipModal(false);
        setAutoMembership(true);
    };

    const handleMembershipNo = () => {
        setShowMembershipModal(false);
    };
    const [couponCode, setCouponCode] = useState('');
    const [couponLoading, setCouponLoading] = useState(false);
    const [couponApplied, setCouponApplied] = useState(false);
    const [discountObj, setdiscountObj] = useState({});

    const validateCoupon = async () => {
        if (individualTicketSelected == null || individualTicketSelected == '') {
            toast.error("Please select Pass Type before adding coupon.");
            return;
        }
        if (couponCode == null || couponCode == '') {
            toast.error("Coupon Code cannot be Blank");
            return;
        }
        setCouponLoading(true);
        const { data: response } = await AxiosInstance.get('/api/validatecoupon?couponcode=' + couponCode.toUpperCase() + "&tickettype=" + encodeURIComponent(individualTicketSelected) + "&eventcode=" + eventInfo.eventcode);
        if (response.result == "Success") {
            setdiscountObj(response.data);
            setCouponApplied(true);
        }
        else {
            setdiscountObj({});
            setCouponApplied(false);
            toast.error("Invalid Coupon Code.");

        }
        setCouponLoading(false);
        return false;
    }
    const removeCoupon = async () => {
        setCouponLoading(true);
        setdiscountObj({});
        setCouponApplied(false);
        setCouponCode('');
        setCouponLoading(false);
        return false;
    }
    return (
        <>
            <form ref={formRef} onSubmit={onformIndividualSubmit}>

                <div className="row">
                    <div className="col-lg-5 col-md-6 col-sm-6">
                        <DropDownComponent names={eventInfo.tickettypes != null ? Object.keys(eventInfo.tickettypes) : []} custname="IdvTicketType" custid="txtidvtickettype" custplaceholder="Pass Type" onExternalValue={setIndividualTicketSelected} />
                        <InputComponent custname="IdvName" custid="txtidvname" custplaceholder="Name" />
                        <InputComponent custname="IdvCompany" custid="txtidvCompany" custplaceholder="Company" />
                        <InputComponent custname="IdvDesignation" custid="txtidvdesignation" custplaceholder="Designation" />
                        <InputComponent custname="IdvMobileNo" custid="txidvtmobile" custplaceholder="Mobile No" />
                    </div>
                    <div className="col-lg-5 col-md-6 col-sm-6">
                        <InputComponent custname="Idvemail" custid="txtidvemail" custplaceholder="Email" />
                        <InputComponent custname="Idvlinkedinurl" custid="txtidvlinkedinurl" custplaceholder="Linkedin Url" />
                        <DropDownComponent names={["Male", "Female", "Other"]} custname="IdvGender" custid="txtidvgender" custplaceholder="Gender" externalstateValue={gender} onExternalValue={setGender} />
                        {eventInfo.additionalFields?.parking.enabled && <DropDownComponent names={["No", "2 Wheeler", "4 Wheeler"]} custname="IdvParking" custid="txtidvparking" custplaceholder="Parking" externalstateValue={parking} onExternalValue={setParking} />}
                        {eventInfo.additionalFields?.tshirt.enabled && <DropDownComponent names={["S", "M", "L", "XL", "XXL", "XXXL"]} custname="IdvTShirtSize" custid="txtidvtshirtsize" custplaceholder="T-Shirt Size" externalstateValue={tshirtsize} onExternalValue={setTshirtsize} />}
                        {individualTicketSelected && eventInfo.tickettypes?.[individualTicketSelected]?.validatemembership === "YES" && (
                            <div className="form-field" style={{ marginTop: '10px' }}>
                                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: '#000', cursor: 'pointer', padding: '0', margin: 0, position: 'relative', fontWeight: 'bold' }}>
                                    <input
                                        type="checkbox"
                                        id="txtautomembership"
                                        checked={autoMembership}
                                        onChange={(e: any) => setAutoMembership(e.target.checked)}
                                        style={{ width: '16px', height: '16px', cursor: 'pointer', position: 'relative', zIndex: 1 }}
                                    />
                                    Auto register membership to avail discount
                                </label>
                            </div>
                        )}

                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-5 col-md-6 col-sm-6">
                        <div className="ticketsummary form-field text-center wow fadeInUp">
                            <span className="ticketsummary-header">Booking Summary</span>
                            {getIndividualTotalPriceTax(eventInfo, individualTicketSelected, discountObj, couponCode)}
                        </div>
                    </div>
                    <div className="col-lg-5 col-md-6 col-sm-6">
                        <div className="form-field text-center wow fadeInUp" data-wow-duration="300ms">
                            <InputComponent custname="IdvCouponcode" custid="txtidvcouponcode" custplaceholder="Coupon Code" onExternalBind={couponCode} readonly={couponApplied} onExternalValue={setCouponCode} toupper={true} trim={true} />
                            {couponApplied ? <button type="button" disabled={couponLoading} onClick={removeCoupon} className="btn-default"> Remove Coupon {couponLoading ? <i className="fa fa-circle-o-notch fa-spin"></i> : <i className="fa fa-arrow-circle-right"></i>}</button> : <button type="button" onClick={validateCoupon} disabled={couponApplied} className="btn-default"> Apply Coupon {couponLoading ? <i className="fa fa-circle-o-notch fa-spin"></i> : <i className="fa fa-arrow-circle-right"></i>}</button>}

                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-3">
                        <div className="form-field text-center mgt-40 wow fadeInUp" data-wow-duration="300ms">
                            <button type="submit" disabled={submitLoading} className="btn-default">REGISTER NOW {submitLoading ? <i className="fa fa-circle-o-notch fa-spin"></i> : <i className="fa fa-arrow-circle-right"></i>}</button>
                        </div>
                    </div>
                </div>
            </form>
            <form ref={idvPayForm} action={process.env.NODE_ENV == "development" ? 'http://localhost:5001/bsidesbangalorev2/us-central1/payments-rpcreateorder' : '/api/rpcreateorder'} >
                <input type="hidden" name="idvpaystring" value={idvPayString} />
            </form>

            {showMembershipModal && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={handleMembershipNo}>
                    <div style={{ backgroundColor: '#fff', borderRadius: '8px', padding: '24px', maxWidth: '420px', width: '90%', boxShadow: '0 4px 20px rgba(0,0,0,0.25)' }} onClick={(e) => e.stopPropagation()}>
                        <h4 style={{ marginTop: 0, marginBottom: '12px', color: '#333' }}>Not a Member</h4>
                        <p style={{ margin: '0 0 20px 0', color: '#555', lineHeight: '1.5' }}>You are not a member. Would you like to become a member by selecting "Auto register membership" to avail discounts?</p>
                        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                            <button type="button" onClick={handleMembershipNo} style={{ padding: '8px 20px', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#f8f9fa', color: '#333', cursor: 'pointer', fontSize: '14px' }}>No</button>
                            <button type="button" onClick={handleMembershipYes} style={{ padding: '8px 20px', border: '1px solid #007bff', borderRadius: '4px', backgroundColor: '#007bff', color: '#fff', cursor: 'pointer', fontSize: '14px' }}>Yes</button>
                        </div>
                    </div>
                </div>
            )}
        </>);
}

function Registration({ eventInfo }: any) {
    const [bookingTypeValue, setBookingTypeValue] = useState('Individual');

    const handleRadioChange = (e: any) => {
        setBookingTypeValue(e.target.value);

    };
const getMessageForStatus = (status:any) =>{
    switch(status)
    {
        case 'CLOSED':
        case 'REGISTRATIONSCLOSED':
        case 'HOLD':
            return "Registration is closed for this event.";
        default:
            return "";
    }
}   
    return (<section id="register" className="register-sec sec-padding" data-scroll-index="8">
        <div className="container">
            <div className="sec-title">
                <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-microphone fa-stack-1x"></i></span></span>
                <h3 className="wow fadeInRight" data-wow-duration="500ms">Regıster now <small>/ Dont mıss the Excitement of Learning!</small></h3>
            </div>

            {eventInfo.status == "REGISTRATIONSCLOSED" || eventInfo.status == "HOLD" || eventInfo.status == "CLOSED" ? <div className="register-sec-details">
                <div className="alert alert-warning text-center" role="alert">
                   <h3> {getMessageForStatus(eventInfo.status)}</h3>
                </div>
            </div> : <div className="register-sec-details">


                <BookingType handleOnChange={handleRadioChange} currentRadioValue={bookingTypeValue} />
                {bookingTypeValue == 'Group' ? <GroupRegistration eventInfo={eventInfo} /> : <IndividualRegistration eventInfo={eventInfo} />}


                <div className="row pt-4">
                    <div className="col-lg-12 col-md-6 col-sm-6">
                        <ul>
                            <li className="warningmg"><i className="fa fa-circle" /> No additional transaction fee of 2.5% will be applied.</li>
                            <li className="warningmg"><i className="fa fa-circle" /> All passes are final sale and non-refundable.</li>
                            <li className="warningmg"><i className="fa fa-circle" /> Please note that the fees mentioned do not include travel expenses and training; They only pertain to entry pass fees.</li>
                        </ul>
                    </div>
                </div>
            </div>} {/* <!--register-sec-details end--> */}
        </div>
    </section>);
};
export default Registration;
